import React, { useState } from "react";
import "../../../pages/ShiftLogs/ShiftLogs.scss";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import EyeIcon from "../../../asset/jobs/EyeIcon.svg";
import CrossIcon from "../../../asset/jobs/close-circle.svg";
import EditIcon from "../../../asset/profile/Edit.png";
import { CircularProgress, Modal, Box, Typography, Button , Tooltip} from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { color } from "@mui/system";
import JobsHeader from "../JobsHeader/JobsHeader";
import BreadCrumb from "../BreadCrumb/BreadCrumb";

import { setJobModal, setJobDetaialsModal } from "../../../redux/userReducer";
import JobOptionModel from "../../Common/JobModal/JobModal";
import JobDetailsModal from "../JobDetailsModal/JobDetailsModal";
import JobPostDetailsModal from "../../PopUp/JobPostDetailsModal/JobPostDetailsModal";
import RevokeOpenJob from "../../PopUp/RevokeOpenJob/RevokeOpenJob";
import { useNavigate } from "react-router-dom";
// import RevokeWithReason from "../../PopUp/RevokeWithReason/RevokeWithReason";
import graphqlRequest from "../../../requestMethod";
import eventHelpers from "../../../Helpers/Event";
import { createSlice } from '@reduxjs/toolkit';
import dayjs from "dayjs";
import EditJobModal from "../JobDetailsModal/EditJobModal";
import { message } from "../SnakeAlert/SnakeAlert";
import { pushEvent } from "../../../utils/clevertap";

const columns = [
  { id: "jobId", label: "Job ID", minWidth: 100 },
  {
    id: "specialization",
    label: "Specialization",
    minWidth: 90,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "startEndDate",
    label: "Start Date & Time ",
    minWidth: 130,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "startEndTime",
    label: "End Date & Time ",
    minWidth: 130,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "positionAvailable",
    label: "Position Available",
    minWidth: 80,
    align: "center",
  },
  {
    id: "applicationsReceived",
    label: "Applications Received",
    minWidth: 80,
    align: "center",
  },
  {
    id: "positionsFilled",
    label: "Positions Filled",
    minWidth: 80,
    align: "center",
  },
  {
    id: "isCamp",
    label: "Camp Duty",
    minWidth: 80,
    align: "center",
  },
  { id: "action", label: "Action", minWidth: 60, align: "center" },
  
];
// function formatTime(timestamp) {
//   const localTime = new Date(timestamp);
//   let hours = localTime.getHours();
//   const minutes = localTime.getMinutes();
//   const amPm = hours >= 12 ? "PM" : "AM";
//   const timeString = `${
//     hours > 12 ? hours - 12 : hours === 0 ? 12 : hours
//   }${amPm}`;
//   return timeString;
// }
function formatTime(timestamp) {
  const localTime = new Date(timestamp);
  let hours = localTime.getHours();
  let minutes = localTime.getMinutes();
  const amPm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Add leading zero to minutes if needed
  minutes = minutes < 10 ? '0' + minutes : minutes;

  const timeString = `${hours}:${minutes} ${amPm}`;
  return timeString;
}
function formatDate(datestamp) {
  let data = datestamp.split(" ");
  return `${data[2]} ${data[1]}`;
}

function createData(
  jobId,
  specialization,
  startEndDate,
  startEndTime,
  positionAvailable,
  applicationsReceived,
  positionsFilled,
  isCamp,
  id,
  contactDetail,
  shiftHours,
  shiftRate,
  cost,
  updatedAt,
  updatedBy,
  marginPercentage,
  updatedSource
) {
  return {
    jobId,
    specialization,
    startEndDate,
    startEndTime,
    positionAvailable,
    applicationsReceived,
    positionsFilled,
    isCamp,
    id,
    contactDetail,
    shiftHours,
  shiftRate,
  cost,
  updatedAt,
  updatedBy,
  marginPercentage,
  updatedSource
  };
}

function JobsTable({
  loading,
  filterTable,
  revokeMiniJobOffers,
  keepMiniJobOffers,
  hospitalBranchValue,
  setHospitalBranchValue,
  professionsValue,
  setProfessionValue,
  fetchOpenJob,
  editOpenJob,
  revokeId,
  setRevokeId,
  reasonToRemove,
  setReasonToRemove,
  totalData, 
  currentPage, 
  limit, 
  setCurrentPage, 
  setLimit
}) {
  // console.log("filterTable2", filterTable);
  let newRow = filterTable?.map((data) =>
    createData(
      data?.code,
      data?.specialization,
      `${dayjs(Number(data?.start)).format('MMM D, YYYY, h:mm A')}`,
      `${dayjs(Number(data?.end)).format('MMM D, YYYY, h:mm A')}`,
      data.filled.split("/")[1],
      data?.applications.split("/")[0],
      data?.filled.split("/")[0],
      data?.campDuty === true ? "Yes" : "No",
      data?.id,
      data?.contactDetail,
      data?.shiftHours,
      data?.maxRate,
      data?.cost,
      `${dayjs(Number(data?.updatedAt)).format('MMM D, YYYY, h:mm A')}`,
      data?.updatedBy,
      data?.marginPercentage,
      data?.updatedSource,
    )
  );
//  console.log("newRow22", newRow);
  let { jobModal, detailsJobModal } = useSelector((state) => state.user);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const handleClose = () => dispatch(setJobModal());
  // const handleCloseDetail = () => dispatch(setJobDetaialsModal());
  const handleCloseDetail = () => {
    setOpenModal(false);
    // fetchOpenJob();
    navigate(0);
    // window.location.reload();
  };

  //
  //table checking start...
  const [page, setPage] = React.useState(0);
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(+event.target.value);
    setCurrentPage(0);
  };

  let [hospitalName, setHospitalName] = useState("");
  let [professionsName, setProfessionsName] = useState("");
  let [openDate, setOpenDate] = useState(false);
  let [selectedData, setSelectedData] = useState({});
  let [editSelected, setEditSelected] = useState({});
  let [jobPostRemoveId, setJobPostRemoveId] = useState({});
  let [revokeConfirmation, setRevokeConfirmation] = useState(false);
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [openModal, setOpenModal] = useState(false);
  
let handleEdit = (data) => {
  const startTime = dayjs(data.startEndDate); 
  const currentTime = dayjs();

  // Allow editing only till 40 minutes before start time
  const lastEditableTime = startTime.subtract(40, "minute");

  if (currentTime.isAfter(lastEditableTime)) {
     message.error("Job cannot be edited 40 minutes before start time.");
    return;
  }

  setEditSelected(data);
  setOpen(true);
}
  let handleView = (data) => {
    pushEvent("Web_View_Open_Job", {
      page: "Open Job",
      section: "Jobs",
      ...data
    });
    console.log("my data", data);
    setSelectedData(data);
    setOpenModal(!openModal);
    // dispatch(setJobDetaialsModal());
  };

  let handleJobPostDelete = (data) => {
    setJobPostRemoveId(data);
    setRevokeConfirmation(!revokeConfirmation);
    // dispatch(setJobModal());
  };

  const fetchUserId = async () => {
    let data = localStorage.getItem("auth");
    let token = JSON.parse(data)?.accessToken;
    try {
      const query = `
    query {
      withAuth(token: "${token}"){
       userDetails{
        id,
        name {
          salutation
          first
          middle
          last
          full
        },
        emails {
          isPrimary
          isVerified
          address
        },
        phoneNumbers{
          number
        }
      }
      }
    }
      `;
      const response = await graphqlRequest(query);
      // console.log("175-->",response)
      return response;
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
    }
  };

  const trackOpenJobAction = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);
      

      //set event data
      // JobID, Accepted , Rejected ,Schedule Interview, Shortlisted,Invite to apply
      window.Moengage.track_event(
        eventHelpers.OPN_JOB_ACTION
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const getTableCellStyle = (column, isHeader = false) => {
    const baseStyle = {
      minWidth: column.minWidth,
      fontSize: isHeader ? "16px" : "15px",
      fontWeight: isHeader ? "500" : "400",
      lineHeight: "18px",
      color: isHeader ? "#FFFFFF" : "#000000",
      backgroundColor: isHeader ? "#2D5FA1" : "#FFFFFF",
      padding: "12px",
      textAlign: column.align || "left",
      zIndex: column.id === "action" && isHeader ? 2 : 1,
    };

    if (column.id === "action") {
      baseStyle.position = "sticky";
      baseStyle.right = 0;
    }

    return baseStyle;
  };

   console.log("newRow", newRow)
   console.log("columns", columns)
  return (
    <>
      <div className="openjob-table">
        <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 5 }}>
          <TableContainer sx={{ 
            maxHeight: 'calc(100vh - 300px)',
            minHeight: 'calc(100vh - 300px)'
          }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => {
                    return column.id === "date" || column.id === "endDate" ? (
                      <TableCell
                        align={column.align}
                        style={getTableCellStyle(column, true)}
                        // style={{
                        //   minWidth: column.minWidth,
                        //   backgroundColor: "#2D5FA1",
                        //   fontSize: "16px",
                        //   fontWeight: "500",
                        //   lineHeight: "18px",
                        //   color: "#FFFFFF",
                        // }}
                      >
                        {column.label}
                        <div
                          className="date-input"
                          style={{
                            display: "flex",
                            flexFlow: "row-reverse",
                            marginTop: "-22px",
                          }}
                        >
                          <CalendarMonthIcon
                            onClick={() => setOpenDate(!openDate)}
                            className="calendar-logo"
                          />
                        </div>

                        {/* {openDate && (
                                <DateRange
                                  editableDateInputs={true}
                                  onChange={(item) => setDate([item.selection])}
                                  moveRangeOnFirstSelection={false}
                                  ranges={date}
                                  className="jobs-date"
                                  style={{position:"absolute", backgroundColor:"#fff  "}}
                                />
                              )} */}
                      </TableCell>
                    ) : (
                      <>
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            ...(column.id === "action" && {
                              position: "sticky",
                              right: 0,
                              // zIndex: 2,
                              backgroundColor: "#2D5FA1",
                            }),
                            minWidth: column.minWidth,
                            backgroundColor: "#2D5FA1",
                            fontSize: "16px",
                            fontWeight: "500",
                            lineHeight: "18px",
                            color: "#FFFFFF",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      </>
                    );
                  })}
                </TableRow>
              </TableHead>

              {loading ? (
                <CircularProgress sx={{ position: "absolute", left: "50%" }} />
              ) : (
                <TableBody>
                  {newRow?.length > 0 ? (
                    newRow
                      ?.slice(
                        // page * rowsPerPage,
                        // page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                      
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.code}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              console.log("value", value)
                              return column.id === "action" ? (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={getTableCellStyle(column)}
                                  // style={{
                                  //   position: "sticky",
                                  //   right: 0,
                                  //   background: "#fff",
                                  //   display: "flex",
                                  //   alignItems: "center", // ✅ vertical alignment
                                  //   justifyContent: "flex-end", // ✅ optional: aligns icons to the right
                                  //   gap: "8px", // ✅ spacing between icons
                                  //   paddingTop: 12,
                                  //   paddingBottom: 12,
                                  //   // zIndex: 2,
                                  // }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px", // spacing between icons
                                    }}
                                  >
                                    <Tooltip title={"Cancel Job"} arrow>

                                    <img
                                      src={CrossIcon}
                                      onClick={() => handleJobPostDelete(row)}
                                      style={{
                                        cursor: "pointer",
                                        width: "20px", // optional size
                                        height: "20px",
                                      }}
                                    />
                                    </Tooltip>
                                    <Tooltip title={"View Job"} arrow>

                                    <img
                                      src={EyeIcon}
                                      alt="view"
                                      onClick={() => {
                                        handleView(row);
                                        trackOpenJobAction();
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        width: "20px", // optional size
                                        height: "20px",
                                      }}
                                    />
                                    </Tooltip>
                                    <Tooltip title={"Edit Job"} arrow>
                                      <img
                                      src={EditIcon}
                                      alt="view"
                                      onClick={() => {
                                       handleEdit(row);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        width: "20px", // optional size
                                        height: "20px",
                                      }}
                                    />
                                    </Tooltip>
                                  </div>
                                </TableCell>
                              ) : (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                              
                            })}
                          </TableRow>
                        );
                      })
                  ) : (
                    // <p style={{ position: "absolute", left: "50%" }}>
                    //   {" "}
                    //   No Data Found
                    // </p>
                    <TableRow>
                      <TableCell 
                        colSpan={columns.length} 
                        sx={{ 
                          textAlign: { xs: 'left', sm: 'center' }, 
                          borderBottom: 'none',
                          height: { xs: 'calc(100vh - 200px)', sm: 'calc(100vh - 300px)' },
                          verticalAlign: 'middle',
                          pl: { xs: 2, sm: 0 }
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: { xs: 'flex-start', sm: 'center' },
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                            textAlign: { xs: 'left', sm: 'center' },
                            pl: { xs: 8, sm: 0 },
                          }}
                        >
                          <WorkOutlineIcon sx={{ fontSize: { xs: 40, sm: 60 }, color: 'primary.main', mb: 2, ml: { xs: 9, sm: 0 } }} />
                          <Typography variant="h6" component="p" gutterBottom sx={{ ml: { xs: 14, sm: 0 } }}>
                            No Open Jobs Found	
                          </Typography>
                          <Typography 
                            variant="body2" 
                            color="text.secondary" 
                            sx={{ 
                              my: 3,
                              fontSize: { xs: '12px', sm: '14px' },
                              lineHeight: { xs: '1.3', sm: '1.5' },
                              maxWidth: { xs: '200px', sm: 'none' },
                              wordBreak: 'break-word',
                              textAlign:'center'
                            }}
                          >
                           There are currently no open job listings. Post a new job to get started.
                          </Typography>
                          <Button  onClick={() => {
                                          pushEvent("Web_Intialize_Job_Post", {
                                            page: "Open Jobs",
                                            section: "Job Post",
                                          });
                                          navigate("/locum-job");
                                        }} variant="contained"
                                        sx={{ 
                                          background: 'linear-gradient(to right, #dc2626, #ef4444)',
                                          borderRadius: '12px', 
                                          mt: 2, 
                                          ml: { xs: 3, sm: 0 },
                                          '&:hover': {
                                            background: 'linear-gradient(to right, #b91c1c, #dc2626)',
                                          }
                                        }} startIcon={<WorkOutlineIcon />}>
                            Post a Job
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
          paginationMode="server"
          pagination
         rowsPerPageOptions={[10, 25, 100]}
         component="div"
         count={totalData}
         rowsPerPage={limit}
         page={currentPage}
         onPageChange={handleChangePage}
         onRowsPerPageChange={handleChangeRowsPerPage}
            // rowsPerPageOptions={[10, 25, 100]}
            // component="div"
            // count={newRow?.length}
            // rowsPerPage={rowsPerPage}
            // page={page}
            // onPageChange={handleChangePage}
            // onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      {/* <Modal
        open={jobModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobOptionModel />
      </Modal> */}

      <Modal
        open={revokeConfirmation}
        onClose={() => {
          setRevokeConfirmation(!revokeConfirmation);
          setReasonToRemove({ reason: "", comment: "", revoke: "" });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RevokeOpenJob
          revokeMiniJobOffers={revokeMiniJobOffers}
          revokeId={revokeId}
          setRevokeId={setRevokeId}
          reasonToRemove={reasonToRemove}
          setReasonToRemove={setReasonToRemove}
          keepMiniJobOffers={keepMiniJobOffers}
          jobPostRemoveId={jobPostRemoveId}
          setRevokeConfirmation={setRevokeConfirmation}
        />
        {/* <RevokeWithReason/> */}
      </Modal>
      <EditJobModal
  open={open}
  onClose={() => setOpen(false)}
  selectedData={editSelected}
  editOpenJob={editOpenJob}
/>

      <Modal
        // open={detailsJobModal}
        open={openModal}
        onClose={handleCloseDetail}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobDetailsModal
          handleCloseDetail={handleCloseDetail}
          selectedData={selectedData}
          fetchOpenJob={fetchOpenJob}
        />
      </Modal>
    </>
  );
}

export default JobsTable;
